import React from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { DeleteForever } from '@mui/icons-material';
import Button from 'react-bootstrap/Button';
import './ToSubheadListComp.css';

const ToSubheadsListComp = ({
    toSubheadsList,
    fy_list,
    fromSchemeDetails,
    screenType,
    total1Amount,
    removeSubhead,
    handleSubmit,
    activity,
    findSubActivitiesById,
    expandedIndex,
    toggleNestedTable
}) => {
    return (
        <>
            <div className="col-md-12">
                <div className="to-subhead-card">
                    <div className="to-subhead-card__header">
                        <p className="to-subhead-card__title">To Subhead</p>
                        <div className="to-subhead-card__meta">
                            <span className="to-subhead-pill">
                                Records: {Array.isArray(toSubheadsList) ? toSubheadsList.length : 0}
                            </span>
                            <span className="to-subhead-pill">
                                Total: {total1Amount?.current ?? 0}
                            </span>
                        </div>
                    </div>

                    <div className="to-subhead-card__body">
                        <div className="table-responsive">
                            <table className="table to-subhead-table w-100">
                                <thead>
                                    <tr>
                                        {fromSchemeDetails.to_is_activity_active == 1 && <th style={{ width: 44 }}> </th>}
                                        <th>Scheme Name</th>
                                        <th>Financial Year</th>
                                        <th>Subhead Name</th>
                                        <th className="text-end">Reappropriation Amount</th>
                                        {screenType != "View" && <th style={{ width: 90 }}>Action</th>}
                                    </tr>
                                </thead>

                                <tbody>
                                    {Array.isArray(toSubheadsList) && toSubheadsList.length > 0 ? (
                                        toSubheadsList.map((e, index) => {
                                            const financial_year = fy_list.find(y => y.id == e.to_financial_id);
                                            const isRowExpanded = expandedIndex === index;

                                    return (
                                        <React.Fragment key={e.to_subhead_id}>
                                            <tr>
                                                {fromSchemeDetails.to_is_activity_active == 1 && <td><span onClick={() => toggleNestedTable(index)} style={{ cursor: 'pointer' }}>
                                                    {isRowExpanded ? <BiChevronUp /> : <BiChevronDown />}
                                                </span></td>}
                                                <td>{e.scheme_name}</td>
                                                <td>{financial_year?.start_year}-{financial_year?.end_year}</td>
                                                <td>{e.subhead_name}</td>
                                                <td className="to-subhead-amount">{e.to_reappropriation_amount}</td>
                                                {screenType != "View" && <td>
                                                    <button type="button"
                                                        className="btn btn-outline-danger to-subhead-icon-btn"
                                                        onClick={(e) => removeSubhead(index, 'to')}>
                                                        <DeleteForever /></button>
                                                </td>}
                                            </tr>
                                            {fromSchemeDetails.to_is_activity_active == 1 && isRowExpanded && (
                                                <tr>
                                                    <td colSpan={screenType != "View" ? 6 : 5}>
                                                        <div className="to-subhead-nested">
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Activity</th>
                                                                    <th>Subactivity</th>
                                                                    {screenType != "View" && <th>Available Balance</th>}
                                                                    <th className="text-end">Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {e.activity && e.activity.length > 0 ? (
                                                                    e.activity.map((activityItem, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <select
                                                                                    className="form-control"
                                                                                    name="activity_id"
                                                                                    value={activityItem.activity_id}
                                                                                    disabled={true}
                                                                                >
                                                                                    <option value="">---Select---</option>
                                                                                    {activity.map(a => (
                                                                                        <option key={a.id} value={a.id}>{a.activity}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <select
                                                                                    className="form-control"
                                                                                    name="subactivity_id"
                                                                                    value={activityItem.subactivity_id}
                                                                                    disabled={true}
                                                                                >
                                                                                    <option value="">---Select---</option>
                                                                                    {findSubActivitiesById(activityItem.activity_id).map(sa => (
                                                                                        <option key={sa.id} value={sa.id}>{sa.subactivity}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </td>
                                                                            {screenType != "View" && <td>{e?.activity_budget && e?.activity_budget.length != 0 && e?.activity_budget.find(e =>
                                                                                e.subhead_activity_id === activityItem.activity_id &&
                                                                                e.subhead_subactivity_id === activityItem.subactivity_id
                                                                            )?.budget}</td>}
                                                                            <td className="text-end fw-600">{activityItem?.budget}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className="text-center">No Details Available</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                                    ) : (
                                        <tr>
                                            <td colSpan={screenType != "View" ? 6 : 5} className="text-center text-muted py-4">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <th colSpan={3}>Total Reappropriation Amount</th>
                                        <th className="text-end">{total1Amount.current}</th>
                                        {screenType != "View" && <th></th>}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    {screenType != "View" && (
                        <div className="to-subhead-footer">
                            <Button
                                type="submit"
                                className="submit_button"
                                onClick={handleSubmit}
                            >
                                Save Budget Reappropriate
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default ToSubheadsListComp;